import React from 'react';
import Alert from '../Alert';

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export default function PartnerDeactivationAlert({
  isOpen, isLoading, onConfirm, onClose,
}: Props): JSX.Element {
  return (
    <Alert
      isOpen={isOpen}
      isLoading={isLoading}
      onConfirm={() => onConfirm()}
      onClose={() => onClose()}
      title="Confirmation"
      confirmLabel="I know what I'm doing"
      cancelLabel="Abort!"
    >
      <p>
        Are you sure you want to deactivate the partner? Feed synchronization will be disabled
        for the partner, its access to the MPI API will be blocked, and communication between
        the MPI and marketplaces will be blocked in both directions.
      </p>
    </Alert>
  );
}
